module.exports = __webpack_public_path__ + "static/media/favicon.100f980b.ico";